import { downloadWithProgress } from '../lib/downloadWithProgress';
import { saveForOffline } from './offlineAudio';

const appendToDownloadHistory = (recording) => {
  try {
    const history = JSON.parse(localStorage.getItem('downloadHistory') || '[]');
    history.unshift({
      id: Date.now(),
      name: recording.title,
      type: 'recording',
      drive_file_id: recording.drive_file_id,
      speaker: recording.speaker,
      timestamp: new Date().toISOString(),
      status: 'completed',
    });
    localStorage.setItem('downloadHistory', JSON.stringify(history.slice(0, 20)));
  } catch { /* quota — ignore */ }
};

export const downloadRecording = async (recording) => {
  const filename = `${(recording.title || 'recording').replace(/[^a-z0-9]/gi, '_')}.mp3`;
  // Mobile / WebView path: `/api/stream/{fid}?dl=1` serves (or 302s to
  // S3 with) `Content-Disposition: attachment` — the native download
  // manager handles it. Desktop keeps the progress-toast fetch which
  // also feeds the offline IndexedDB cache.
  const streamUrl = recording.stream_url || `/api/stream/${recording.drive_file_id}`;
  const sep = streamUrl.includes('?') ? '&' : '?';
  const attachmentUrl = `${streamUrl}${sep}dl=1&name=${encodeURIComponent(filename)}`;
  const ok = await downloadWithProgress(
    streamUrl,
    filename,
    recording.title,
    async (blob) => { await saveForOffline(recording, blob); },
    attachmentUrl,
  );
  if (ok) appendToDownloadHistory(recording);
};
